import { SelectFieldOptions } from "@picovico/ui";

export const GENDER_OPTION: SelectFieldOptions<string> = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];
